module.exports = __webpack_public_path__ + "fonts/regular.8ccc24f0.ttf";